export default __webpack_public_path__ + "static/media/Poppins-Black.d8b850b9.ttf";